import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Field, StyledInput } from 'pages/ManageClubEurostar/ManageClubEurostar.styles';
import Label from 'components/ui/Label';
import { isValidPassengersNumber } from 'utils/validators';

import { AddCompanionsWrapper } from './AddPassengersCta.styles';

const AnimalsBookings = ({ register, errors }) => (
  <AddCompanionsWrapper>
    <Field>
      <Label htmlFor="guideDogs">
        <FormattedMessage id="passengerType.guideDog" />{' '}
      </Label>
      <StyledInput
        {...register('guideDogs', {
          validate: (value) => !value || (isValidPassengersNumber(value) && Number(value) <= 1)
        })}
        type="number"
        inputMode="numeric"
        id="guideDogs"
        data-testid="guideDogs"
        validationState={errors.guideDogs ? 'error' : ''}
        min={0}
        max={1}
      />
    </Field>
  </AddCompanionsWrapper>
);

AnimalsBookings.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.shape({
    guideDogs: PropTypes.string
  })
};

export default AnimalsBookings;
